import { render, staticRenderFns } from "./ModalAddPatientsImport.vue?vue&type=template&id=1980e296&scoped=true"
import script from "./ModalAddPatientsImport.vue?vue&type=script&lang=js"
export * from "./ModalAddPatientsImport.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPatientsImport.vue?vue&type=style&index=0&id=1980e296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980e296",
  null
  
)

export default component.exports